import React, { Component } from 'react'

export default class VectorLayersExample extends Component {
  render() {
    global.menu = 2;

    return (
        <div className="layout text">
            <h1>Bienvenue sur Neo4Tourism</h1>
            Ce travail repose sur des travaux de recherche effectués au sein du laboratoire <a href="https://www.devinci.fr/research-center/">DVRC</a>. Vous pourrez trouver les références correspondantes ci-dessous :
            <ul>
              <li>Djebali S., Loas N., Travers N. (2020) <b>Indicators for Measuring Tourist Mobility</b>. In: Web Information Systems Engineering – WISE 2020. LNCS, vol 12342. Springer, Cham. <a href="https://doi.org/10.1007/978-3-030-62005-9_29">https://doi.org/10.1007/978-3-030-62005-9_29</a></li>
              <li>Chareyron G., Quelhas U., Travers N. (2020) <b>Tourism Analysis on Graphs with Neo4Tourism</b>. In:  Web Information Systems Engineering. WISE 2020. CCIS, vol 1155. Springer, Singapore. <a href="https://doi.org/10.1007/978-981-15-3281-8_4">https://doi.org/10.1007/978-981-15-3281-8_4</a></li>
            </ul>
        </div>
    )}
}
